package games.polyclub.website.frontend.store.layout

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.frontend.lib.react.utils.pData
import games.polyclub.tool.strings.id.UniqueId
import games.polyclub.website.frontend.store.context.useCart
import games.polyclub.website.frontend.store.sitemap.LoggedSitemap
import react.Props
import react.dom.aria.AriaRole
import react.dom.aria.ariaHidden
import react.dom.aria.ariaLabel
import react.dom.aria.ariaLabelledBy
import react.router.dom.Link
import react.useState
import web.html.ButtonType

val ProductAddedModal = SFC<Props> { _ ->
    val cart = useCart()
    val (modalTitleId) = useState(UniqueId().toString())
    div("modal fade") {
        ref = cart.modalRef
        tabIndex = -1
        role = AriaRole.dialog
        ariaLabelledBy = modalTitleId
        ariaHidden = true
        div("modal-dialog modal-dialog-centered") {
            role = AriaRole.document
            div("modal-content") {
                div("modal-header") {
                    h5("modal-title") {
                        id = modalTitleId
                        +"Finalizar Compra?"
                    }
                    button("close") {
                        type = ButtonType.button
                        pData("dismiss", "modal")
                        ariaLabel = "Fechar"
                        span {
                            ariaHidden = true
                            +Typography.times
                        }
                    }
                }
                div("modal-body") {
                    div("row") {
                        div("col") {
                            p {
                                +"O produto foi adicionado ao carrinho."
                            }
                            p("mt-4 mb-0") {
                                +"Deseja fechar a compra agora?"
                            }
                        }
                        div("col-4") {
                            i("fas fa-cart-arrow-down fa-7x")
                        }
                    }
                }
                div("modal-footer") {
                    button("btn btn-outline-secondary btn-block") {
                        pData("dismiss", "modal")
                        +"Escolher Mais Itens"
                    }
                    Link("btn btn-primary btn-block mt-0") {
                        onClick = {
                            cart.hideModal(false)
                        }
                        to = LoggedSitemap.CART.path
                        +"Finalizar Compra"
                    }
                }
            }
        }
    }
}
